import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { PlatformService } from "./platform.service";

@Injectable({
  providedIn: "root",
})
export class NavigateToMessagesService {
  constructor(
    private router: Router,
    private platformService: PlatformService,
  ) {
  }

  navigateToMessages() {
    const isPaidPlatform = this.platformService.isPaidByLandingFlow();
    const messagePath = isPaidPlatform ? "/paid/message" : "/message";

    this.router.navigate([messagePath]);
  }
}
